import React, { useState } from 'react';
import character from '../img/343433443-Photoroom.png';
import bg from '../img/bg.png';
import pattern from '../img/cubes.png'
import NominationsTable from './NominationsTable';
import CriteriaModal from './CriteriaModal';
import RegulationModal from './RegulationModal';
import ProcedureTable from './ProcedureTable';
import ProjectsTableModal from './ProjectsTableModal';
import ExpertsTableModal from './ExpertsTableModal';
import ApplicationForm from './ApplicationForm';
import ContBg from '../img/cont-bg.svg'
import ContactPhoto from '../img/408318687_8c82da02-f01c-4ea3-9c63-e6d3358849e5.jpg'
import DocPhoto from '../img/doc.png'

const sections = [
  {
    title: 'География и масштаб',
    color: '#8C4DFF',
    items: [
      'География участников — 42 страны на пяти континентах: Canada, United States of America, Mexico, Brazil, Chile, Argentina, United Kingdom, Germany, France, Spain, Italy, Netherlands, Belgium, Sweden, Norway, Finland, Denmark, Poland, Czech Republic, Hungary, Romania, Bulgaria, Greece, Portugal, Estonia, Latvia, Lithuania, Ukraine, Russia, Belarus, Moldova, Armenia, Azerbaijan, Georgia, Kazakhstan, Uzbekistan, Kyrgyzstan, Tajikistan, Turkmenistan, Japan, South Africa, India.',
      '150+ регионов охвачены локальными профессиональными лидами.',
      '2 600+ команд подали заявки за пять сезонов; 320 вышли в полуфинал, 50 — в финал.'
    ]
  },
  {
    title: 'Как подать заявку — 5 шагов',
    color: '#FFBC00',
    items: [
      'До 15 сентября: Заполните онлайн‑форму: короткое описание идеи, 60‑секундное видео капитана и презентация MVP.',
      '25 сентября: Получите e‑mail‑подтверждение и уникальный ID‑код команды.',
      'Соберите 3–6 участников: Укажите роли и выберите три фокус‑страны для будущей адаптации бренда.',
      '1–3 ноября — онлайн‑хакатон: Работайте на платформе MAMI Connect, проходите стендапы с менторами и дорабатывайте бренд‑пакет.',
      '3 ноября, 18:00 (EEST): Защитите проект на live‑питче перед жюри и всей онлайн‑аудиторией BrandGlobe Hackathon.'
    ]
  },
  {
    title: 'Правила и дедлайны',
    color: '#8C4DFF',
    items: [
      'Один проект — одна команда.',
      'Команда должна показать адаптацию бренда для трёх культур (язык, визуальный код, каналы).',
      'Финальные материалы: логотип в SVG, медиаплан, видео‑питч (до 3 минут).'
    ]
  }
];


const Hero = () => {
  const [open, setOpen] = useState(false);

  return (
  
  <>
  <section className="hero" style={{ backgroundImage: `url(${bg})` }}>
    <div className="hero__content">
      <h1 className="hero__title">
Создаем бренды, которые охватывают весь земной шар
      </h1>
      <div className="hero__banner"><p>BrandGlobe Hackathon</p></div>
      {/* Кнопка теперь <a> для ссылки */}
      <a href="#application" className="hero__button">
        Подать заявку
      </a>
    </div>
    <div className="hero__image">
      <img src={character} alt="Character" />
    </div>
  </section>

   <section className="brandhackathon">
        <img src={pattern} alt="" className="brandhackathon__pattern" />
    <div className='container'>

      <div className="brandhackathon__header">
        <h1 className="brandhackathon__title">
          Добро пожаловать на Международный BrandGlobe Hackathon!
        </h1>
      </div>


    <p className="brandhackathon__text">
      Из самого сердца Украины мы объединяем креативные команды со всего мира, чтобы за 48 часов родились цифровые бренды глобального масштаба. Погрузитесь в онлайн‑пространство, где командная смелость и инновационность встречаются с мультикультурными идеями — и вместе создайте бренд, который охватит весь шар!
    </p>

    <h2 className="brandhackathon__subtitle">Организаторы Хакатона:</h2>
    <p className="brandhackathon__text">
      BrandGlobe Hackathon проводит Международная Ассоциация Маркетинговых Инициатив (МАМИ) — ведущая украинская платформа развития креативной индустрии и маркетинга{' '}
      <a href="https://mami.org.ua" target="_blank" rel="noopener noreferrer">mami.org.ua</a>. Все этапы хакатона проводятся онлайн: команды формируются, общаются и презентуют проекты через защищенную цифровую платформу МАМИ.
    </p>

    <h2 className="brandhackathon__subtitle">Миссия</h2>
    <p className="brandhackathon__text">
      Наша цель — помочь талантливым маркетологам, дизайнерам и стратегам за 48 часов создать цифровой бренд, способный органично работать минимум в трех странах. Мы продвигаем:
    </p>
    <ul className="brandhackathon__list">
      <li>кросс‑культурное мышление;</li>
      <li>инклюзивный дизайн и этику;</li>
      <li>устойчивые digital‑подходы к развитию бизнеса и социальных инициатив.</li>
    </ul>
    <h2 className="brandhackathon__subtitle">Освещение в СМИ</h2>
    <p className="brandhackathon__text">О лучших решениях BrandGlobe писали RIA Новости (спецрепортаж «Digital-бренды без границ», 2022) и Euronews (рубрика Tech-Innovation, 2023). Материалы также выходили на Creativity.ua, AdWeek Europe и в подкасте Marketing Tomorrow.</p>
    </div>

      <section className="cta-block">
    <h2 className="cta-block__title">Готовы бросить вызов миру?</h2>
    <p className="cta-block__text">
      Подайте заявку уже сегодня и создайте бренд, который охватит весь шар.
    </p>
    <a href="#application" className="cta-block__button">
  Подать заявку
</a>
  </section>

  
  </section>

<div className="cards-section">
  {/* Карточка 1 */}
  <div className="card">
    <h3 className="card__title">Механизм оценки</h3>
    <p className="card__text">
      Проекты оценивает международное жюри из 20 экспертов. Чтобы исключить предвзятость, работы подаются анонимно (ID вместо названий).
    </p>
    <ul className="card__list">
      <li><strong>Глобальный потенциал бренда</strong> — 30 %</li>
      <li><strong>Креативность и дизайн</strong> — 20 %</li>
      <li><strong>Культурная адаптация</strong> — 20 %</li>
      <li><strong>Digital‑стратегия и медиаплан</strong> — 15 %</li>
      <li><strong>Жизнеспособность модели</strong> — 15 %</li>
    </ul>
    <p className="card__text">
      Максимум — 100 баллов. Десять лучших команд выходят в суперфинал, где открывается авторство и объявляется победитель.
    </p>
  </div>

  {/* Карточка 2 */}
  <div className="card">
    <h3 className="card__title">Статистика участия</h3>
    <ul className="card__list">
      <li><strong>Среднее число заявок</strong> за все время: 2600</li>
      <li><strong>Допущены к хакатону</strong>: 60 %</li>
      <li><strong>Финалисты</strong>: 3 %</li>
      <li><strong>Победитель в каждой номинации</strong>: 0,3 % (1 команда)</li>
    </ul>


  </div>


  {/* Карточка 4 */}
  <div className="card">
    <h3 className="card__title">Призы и награды</h3>
    <ul className="card__list">
      <li>BrandGlobe Cup — дизайнерский кубок с NFC‑меткой победителя</li>
      <li>$10 000 грант на запуск кампании через партнерские медиа</li>
      <li>Дипломы и сертификаты CPD для всех финалистов</li>
      <li>Fast‑track в МАМИ‑Акселератор: доступ к менторству и инвесторам</li>
    </ul>
  </div>


</div>


  <section className="steps-rules">
    <div className="steps-rules__container">
      {sections.map(({ title, color, items }) => (
        <div className="steps-rules__section" key={title}>
          <div
            className="steps-rules__sidebar"
            style={{ backgroundColor: color }}
          >
            <div className="steps-rules__sidebar-title">{title}</div>
          </div>
          <div className="steps-rules__content">
            {items.map((text, idx) => (
              <div className="steps-rules__item" key={idx}>
                {text}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
      <CriteriaModal/>
      <RegulationModal/>
  </section>
  <ProjectsTableModal/>

  <NominationsTable/>

  <ExpertsTableModal/>

  <ApplicationForm/>

  <section id='contacts' className="contacts">
    <div className="contacts__container">
      <div className="contacts__info">
        <h2 className="contacts__heading">Контакты</h2>
        <p className="contacts__text">
          <strong>E‑mail:</strong>{' '}
          <a href="mailto:info@mami.com.ua" className="contacts__link">
            info@mami.com.ua
          </a>
        </p>
        <p className="contacts__text">
          <strong>Web‑сайт:</strong>{' '}
          <a
            href="https://www.mami.org.ua"
            target="_blank"
            rel="noopener noreferrer"
            className="contacts__link"
          >
            www.mami.org.ua
          </a>
        </p>
        <p className="contacts__text"><strong>Почтовый адрес:</strong> вул. Воздвиженська, 41, м. Київ, Україна</p>
        <p className="contacts__text"><strong>Тел.:</strong> +38 (067) 657‑24‑02</p>
          <ProcedureTable/>

              <>
      <button className="image-button" onClick={() => setOpen(true)}>
        Диплом
      </button>

      {open && (
        <div className="image-modal__overlay" onClick={() => setOpen(false)}>
          <div
            className="image-modal__content"
            onClick={e => e.stopPropagation()}
          >
            <button
              className="image-modal__close"
              onClick={() => setOpen(false)}
            >
              ×
            </button>
            <img
              src={DocPhoto}
              alt="Описание"
              className="image-modal__img"
            />
          </div>
        </div>
      )}
    </>
      </div>
      <div className="contacts__image-wrapper">
        {/* Левый паттерн */}
        <div
          className="contacts__pattern contacts__pattern--left"
          style={{ backgroundImage: `url(${ContBg})` }}
        />
        {/* Правый паттерн */}
        <div
          className="contacts__pattern contacts__pattern--right"
          style={{ backgroundImage: `url(${ContBg})` }}
        />
        {/* Круглая фотография */}
        <img
          src={ContactPhoto}
          alt="Контактное лицо"
          className="contacts__image"
        />
      </div>
    </div>
  </section>


  </>
  );
};

export default Hero;